import { render, staticRenderFns } from "./ListadoDevoluciones.vue?vue&type=template&id=0dfca870&"
import script from "./ListadoDevoluciones.vue?vue&type=script&lang=js&"
export * from "./ListadoDevoluciones.vue?vue&type=script&lang=js&"
import style0 from "./ListadoDevoluciones.vue?vue&type=style&index=0&id=0dfca870&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports